import angular from 'angular';

const FORMAT = 'YYYY-MM-DD';

module.exports = angular.module('common.components.od-flip-dates', [
  require('common/filters/pretty'),
  require('common/filters/sorted-keys'),
  require('common/filters/titlecase'),
])
.component('odFlipDates', {
  require: { flipDatesCtrl: '^odFlipDatesContainer' },
  template: require('./od-flip-dates.jade')(),
  controller: class OdFlipDatesCtrl {
    $onInit() {
      this.FORMAT = this.flipDatesCtrl.format || FORMAT;
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/od-flip-dates.js
 **/